<template>
  <div>
    <div class="project-meta">
      <div class="project-entrant">
        <span class="project-entrant-dob">
          Born {{entry.entrantInfo.dateOfBirth}} in
          <span
            class="project-entrant-birthPlace"
          >{{entry.entrantInfo.birthPlace | lowercase}}, {{entry.entrantInfo.birthCountry | lowercase}}.</span>
        </span>
        <span
          class="project-entrant-resident"
        >Lives {{entry.entrantInfo.residentPlace | lowercase}}, {{entry.entrantInfo.residentCountry | lowercase}}.</span>
        <span class="project-entrant-address">{{entry.entrantInfo.address}}</span>
      </div>
      <div class="project-entrant-contact">
        <span class="project-entrant-www" v-if="entry.entrantInfo.website">
          <a :href="entry.entrantInfo.website" target="_blank">website</a>
        </span>
        <span class="project-entrant-instagram" v-if="entry.entrantInfo.instagram">
          <a
            :href="hasUrl(entry.entrantInfo.instagram, 'https://www.instagram.com/')"
            target="_blank"
          >instagram</a>
        </span>
        <span class="project-entrant-twitter" v-if="entry.entrantInfo.twitter">
          <a
            :href="hasUrl(entry.entrantInfo.twitter, 'https://www.twitter.com/')"
            target="_blank"
          >twitter</a>
        </span>
        <span class="project-entrant-email">
          <a :href="'mailto'+entry.email">{{entry.email}}</a>
        </span>
        <span class="project-entrant-phone">{{entry.entrantInfo.telephone}}</span>
      </div>
    </div>
    <!-- .project-meta-->
  </div>
</template>

<script>
export default {
  computed: {
    hasUrl: () => (str, needle) => {
      if (str.includes(needle)) {
        return str
      }
      if (str.charAt(0) === '@') {
        return needle + str.substr(1)
      }
      return needle + str
    }
  },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    lowercase: value => {
      return value.toLowerCase()
    }
  }
}
</script>

<style scoped>
.project-entrant-address,
.project-entrant-birthPlace,
.project-entrant-resident,
.project-entrant-birthPlace {
  text-transform: capitalize;
}

.project-photographer:before {
  content: ' by ';
  text-transform: lowercase;
}
.project-entrant-contact span:before {
  content: ' | ';
}
.project-entrant-contact span:first-child:before {
  content: '';
}
.project-entrant-resident {
  padding-left: 0.5em;
}
.project-entrant-address {
  font-style: italic;
  font-size: 0.9em;
  padding-left: 0.5em;
}
.project-entrant-contact a {
  color: #707070;
  text-decoration: underline;
}
.project-entrant-contact a:hover {
  color: #343a40;
  text-decoration: underline;
}
</style>
